import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, UserCog } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useCustomer } from "../context/CustomerContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/track", label: "Track Order" },
  { to: "/returns", label: "Returns" },
];

export const Navbar = () => {
  const { count } = useCart();
  const { customer, logout } = useCustomer();
  return (
    <header className="sticky top-0 z-40 glass" data-testid="storefront-navbar">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <img src="/logo192.png" alt="TrendDrop logo" className="h-9 w-9 rounded-xl" />
          <span className="font-heading text-xl font-bold tracking-tight text-white">
            Trend<span className="text-amber-400">Drop</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-7 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${isActive ? "text-amber-400" : "text-slate-300 hover:text-white"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {customer ? (
            <>
              <span className="hidden text-xs text-slate-400 sm:block" data-testid="nav-customer-greeting">
                Hi, {customer.name?.split(" ")[0]}
              </span>
              <button
                data-testid="nav-logout-btn"
                onClick={logout}
                className="rounded-full border border-white/10 px-3.5 py-1.5 text-xs font-medium text-slate-400 transition-colors hover:border-rose-400/40 hover:text-rose-300"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/auth"
                data-testid="nav-login-btn"
                className="rounded-full border border-white/10 px-3.5 py-1.5 text-xs font-medium text-slate-300 transition-colors hover:border-amber-400/40 hover:text-amber-300"
              >
                Log in
              </Link>
              <Link
                to="/auth?mode=signup"
                data-testid="nav-signup-btn"
                className="rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold text-black transition-colors hover:bg-amber-300"
              >
                Sign up
              </Link>
            </>
          )}
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="hidden items-center gap-1.5 rounded-full border border-white/10 px-3.5 py-1.5 text-xs font-medium text-slate-400 transition-colors hover:border-amber-400/40 hover:text-amber-300 lg:flex"
          >
            <UserCog size={14} /> Owner
          </Link>
          <Link
            to="/cart"
            data-testid="nav-cart-button"
            className="relative flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-200 transition-colors hover:border-amber-400/50 hover:text-amber-300"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-amber-400 px-1 text-[11px] font-bold text-black"
              >
                {count}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};
